module.exports = __webpack_public_path__ + "static/media/tips.dd69f89f.png";